import React from 'react';
import {
    Grid,
    Typography,
    TextField,
    Button,
    Dialog,
    DialogContent,
    MenuItem,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { toast } from 'react-toastify';
import AppDialogTitle from '../../../ui/appDialogTitle';
import { isLocalDev } from '../../../../utils/environment';
import { LensConfigurationService } from '../../../../service/validDataService';
import validLookup from '../../../../utils/validLookup';

export const initialValuesLensMaterialForm = {
    name: '',
    status: validLookup.validStatus.active,
    notes: '',
};

export default function ValidLensMaterialInputForm({ open, onClose, onRecordAdded }) {

    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        try {
            const response = await LensConfigurationService.addMaterial(values)
            const { code, data, message } = response

            setSubmitting(false)

            if (code === 0) {
                toast.success(message);
                resetForm();
                onRecordAdded(data)
                onClose();
            } else {
                toast.error(message);
            }
        } catch (error) {
            if (isLocalDev) {
                console.error(error);
            }
            setSubmitting(false)
            toast.error('Failed to add lens material');
        }
    };

    return (
        <Dialog open={open} maxWidth={'sm'} fullWidth>
            <AppDialogTitle title={"Add Lens Material"} onClose={onClose} />
            <DialogContent sx={{ mt: 1, mb: 1 }}>
                <Formik
                    initialValues={initialValuesLensMaterialForm}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <Grid container spacing={2} sx={{mt: 1}}>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="name"
                                        label="Material Name"
                                        required
                                        fullWidth
                                        size="small"
                                        helperText="e.g., Polycarbonate, CR-39, Trivex, High-Index Plastic"
                                    />
                                    <ErrorMessage name="name">{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name='status'
                                        label="Status"
                                        fullWidth
                                        select
                                        size="small"
                                    >
                                        <MenuItem value={"active"}>Active</MenuItem>
                                        <MenuItem value={"inactive"}>Inactive</MenuItem>
                                    </Field>
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="notes"
                                        label="Notes"
                                        multiline
                                        rows={3}
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        disabled={isSubmitting}
                                    >
                                        Create
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};
